import React, { useState, useEffect, useContext } from 'react';
import styled from 'styled-components';
import { EventDatetimeContext } from 'components/EventDatetime';
import remoteTimeNow from 'libs/remote-time-now';

const TimerContainer = styled.div`
  margin: auto;
  width: 100%;
  display: flex;
  justify-content: space-between;
  z-index: 1;
  max-width: 606px;
`;

const NumberWrapper = styled.div`
  display: flex;
  flex-direction: column;
  color: #FFF;
  font-size: 24px;
  text-align: center;
  align-items: center;
`;

const NumberContainer = styled.div`
  width: min(20vh, 20vw);
  max-width: 50px;
  height: min(20vh, 20vw);
  max-height: 50px;
  background: #DADADA;
  color: #282B40;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 30px;
  text-align: center;
  position: relative;
  transition: all 1s;

  @media only screen and (min-width: 400px) {
    max-width: 70px;
    max-height: 70px;
    font-size: 50px;
  }

  @media only screen and (min-width: 500px) {
    max-width: 80px;
    max-height: 80px;
    font-size: 60px;
  }

  @media only screen and (min-width: 610px) {
    max-width: 110px;
    max-height: 110px;
    font-size: 80px;
  }

  @media only screen and (min-width: 750px) {
    max-width: 130px;
    max-height: 130px;
    font-size: 100px;
  }
`;

const DayTimeText = styled.span`
  color: #FFF;
  font-size: 10px;
  display: block;
  margin-top: 8px;
  font-weight: 600;

  @media only screen and (min-width: 900px) {
    font-size: 16px;
  }
`;

function leftpadZero(num) {
  const str = num.toString();
  return str.length >= 2 ? str : `0${str}`;
}

function timeDiff(destination, source) {
  const days = destination.diff(source, 'days');
  const hours = destination.diff(source, 'hours') % 24;
  const minutes = destination.diff(source, 'minutes') % 60;
  const seconds = destination.diff(source, 'seconds') % 60;
  return {
    days, hours, minutes, seconds,
  };
}

const Countdown = () => {
  const { registerStartDatetime } = useContext(EventDatetimeContext);
  const [days, setDays] = useState(0);
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      const newNow = remoteTimeNow();
      const td = timeDiff(registerStartDatetime, newNow);
      setDays(td.days);
      setHours(td.hours);
      setMinutes(td.minutes);
      setSeconds(td.seconds);
    }, 1000);

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [registerStartDatetime]);

  return (
    <TimerContainer>
      <NumberWrapper>
        <NumberContainer>
          {leftpadZero(days)}
        </NumberContainer>
        <DayTimeText>
          {`DAY${days > 1 ? 'S' : ''}`}
        </DayTimeText>
      </NumberWrapper>
      <NumberWrapper>
        <NumberContainer>
          {leftpadZero(hours)}
        </NumberContainer>
        <DayTimeText>
          {`HOUR${hours > 1 ? 'S' : ''}`}
        </DayTimeText>
      </NumberWrapper>
      <NumberWrapper>
        <NumberContainer>
          {leftpadZero(minutes)}
        </NumberContainer>
        <DayTimeText>
          {`MINUTE${minutes > 1 ? 'S' : ''}`}
        </DayTimeText>
      </NumberWrapper>
      <NumberWrapper>
        <NumberContainer>
          {leftpadZero(seconds)}
        </NumberContainer>
        <DayTimeText>
          {`SECOND${seconds > 1 ? 'S' : ''}`}
        </DayTimeText>
      </NumberWrapper>
    </TimerContainer>
  );
};

export default Countdown;
